/**
 * Google Enhanced Ecommerce Object
 *
 * Checkout related logic and functionality for Google Enhanced Ecommerce.
 * https://confluence.int.plus.net/display/DIGITAL/Google+Enhanced+Ecommerce
 */
const checkout = {
    /**
     * Initialise
     *
     * @param  {object}  option, pagePath, referringPagePath
     * @param  {string}  pagePath
     *
     * @returns  {void}
     */
    initialise: ({option, pagePath, referringPagePath = ''} = {}) => {

        if (!gaEcommerce.core.checkStorageCapabilities()) return;

        // pagePath is an optional override should you ever need to send a step that differs from the page its on
        if (typeof pagePath === 'undefined') {
            pagePath = window.location.pathname;
        }

        // Get step from page list
        const stepNumber = gaEcommerce.steps.getFunnelStep(pagePath);

        if (stepNumber) {

            // Fire pseudo checkout step for broadband in account change if customer lands on phone
            gaEcommerce.checkout.pseudoLandingSteps(stepNumber, referringPagePath);

            // Check that the referrer was previous step and if not fire checkout steps
            gaEcommerce.checkout.pseudoSteps(stepNumber, referringPagePath);

            const checkoutData = {
                "step": stepNumber
            };

            // Setup step and data if option exists add to object.
            if (typeof option !== 'undefined') {
                checkoutData.option = option;
            }

            // Include the journey name so we can identify where the checkout step came from
            checkoutData['dimension48'] = gaEcommerce.core.getJourney();

            gaEcommerce.core.sendData({
                "checkout": {
                    "actionField": checkoutData
                }
            }, "checkout");

            clientData.storage.setData({name: 'ecomStep', value: stepNumber}, 'cookie');
        }
    },

    /*
     * pseudoSteps
     *
     * @param {int} stepNumber
     * @param {string} referringPagePath
     *
     * @return {void}
     */
    pseudoSteps: (stepNumber, referringPagePath = '') => {
        // Fire pseudo funnel steps should the referrer not be the previous step
        const ecomStep = clientData.storage.getCookie('ecomStep');

        referringPagePath = referringPagePath
            || document.referrer?.replace(/^[^:]+:\/\/[^/]+/, "").replace(/#.*/, "");

        if (ecomStep && referringPagePath && stepNumber !== parseInt(ecomStep)) {

            const referringPageStep = gaEcommerce.steps.getFunnelStep(referringPagePath);

            if (referringPageStep) {
                for (let i = (referringPageStep + 1); i < stepNumber; i++) {
                    gaEcommerce.core.sendData({
                        checkout: {
                            actionField: {
                                "step": i,
                                "option": "Step not required",
                                "dimension48": gaEcommerce.core.getJourney()
                            }
                        }
                    }, 'checkout');
                }
            }
        }
    },

    /*
     * pseudoLandingSteps
     *
     * @param {int} stepNumber
     * @param {string} referringPagePath
     *
     * @return {void}
     */
    pseudoLandingSteps: (stepNumber, referringPagePath = '') => {

        if (!(
            gaEcommerce.util.isAccountChange()
            || gaEcommerce.util.isLegacyAccountChange()
        )) {
            return;
        }

        referringPagePath = referringPagePath
            || document.referrer?.replace(/^[^:]+:\/\/[^/]+/, "").replace(/#.*/, "");

        const steps = gaEcommerce.util.isAccountChange
            ? gaEcommerce.steps.accountChangeSteps
            : gaEcommerce.steps.legacyAccountChangeSteps;

        const isOnPhoneStep = (stepNumber === steps.phone),
              noReferringPageStep = (gaEcommerce.steps.getFunnelStep(referringPagePath) === undefined),
              notRefreshed = (stepNumber !== parseInt(clientData.storage.getCookie('ecomStep')));

        if (isOnPhoneStep && noReferringPageStep && notRefreshed) {

            for (let i = 1; i < stepNumber; i++) {
                gaEcommerce.core.sendData({
                    checkout: {
                        actionField: {
                            "step": i,
                            "option": "Step not required",
                            "dimension48": gaEcommerce.core.getJourney()
                        }
                    }
                }, 'checkout');
            }
        }
    }
};

export default checkout;
